"use client"

import React from 'react'
import SignUpForm from '../../components/signUpForm/SignUpForm'
import Head from "next/head";


const Index = () => {
  return (
    <>

    <Head>
    <title>Join Our Community | Living Circle of Wisdom | Perennial Mandalism</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Spiritual Community, Join Community, Living Circle of Wisdom, Perennial Mandalism, Astrology, Tarot, Yoga, Meditation, Jungian Archetypes, Chart Readings"
    ></meta>
    <meta
      property="og:title"
      content="Join Our Living Circle of Wisdom: A Community for Spiritual Growth"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/perennial_signup_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="The logos for the School of Our Divine Infinite Being and Perennial Mandalism, representing a community dedicated to astrology, theurgy, and perennial wisdom."
    ></meta>
    <meta
      property="og:description"
      content="Join our Living Circle of Wisdom, a heart-centered community honoring Astrology, Tarot, and perennial wisdom. Get personalized chart readings, join monthly rituals, and grow with a spiritual family."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/perennial-signup"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/perennial_signup_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="The logos for the School of Our Divine Infinite Being and Perennial Mandalism, representing a community dedicated to astrology, theurgy, and perennial wisdom."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/perennial-signup"
    ></meta>
    <meta
      name="twitter:title"
      content="Join Our Living Circle of Wisdom: A Community for Spiritual Growth"
    ></meta>
    <meta
      name="twitter:description"
      content="Join our Living Circle of Wisdom, a heart-centered community honoring Astrology, Tarot, and perennial wisdom. Get personalized chart readings, join monthly rituals, and grow with a spiritual family."
    ></meta>
    <link rel="canonical" href="https://www.divineinfinitebeing.com/perennial-signup" />
</Head>
    <div>
      <SignUpForm/>
    </div>
    </>
  )
}

export default Index
